import React, { useState, useRef } from 'react';
import { Card, Space, Typography, Button, Tooltip } from 'antd';
import {
  CopyOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import { CodeBlock } from 'react-code-blocks';
import GenTagInstructionsModal from './GenTagInstructionsModal';
import GeneratedImagePixelTagModal from './GeneratedImagePixelTagModal';
import GeneratedTagsCardStyles from '../../styles/GeneratedTagsCardStyles';
import { space } from '../../../Tasks/configs/designTokens';
import '../../styles/index.scss';

const { Text } = Typography;

const GeneratedTagsCard = ({ generatedTag, details }) => {
  const { tag, cart } = generatedTag;
  const { appId } = details;
  const generatedTagValue = tag ? tag.generatedTag : '';

  const [isCopied, setIsCopied] = useState(false);
  const copyTimeoutRef = useRef(null);

  const handleCopy = () => {
    if (copyTimeoutRef.current) {
      clearTimeout(copyTimeoutRef.current);
    }

    navigator.clipboard.writeText(generatedTagValue);
    setIsCopied(true);

    copyTimeoutRef.current = setTimeout(() => {
      setIsCopied(false);
      copyTimeoutRef.current = null;
    }, 3000);
  };

  return (
    <Card
      title="GENERATED TAG"
      className="tags-card"
      extra={<GenTagInstructionsModal cart={cart} generatedTag={generatedTagValue} />}
    >
      <div className="tags-generated__image-pixel-row">
        <GeneratedImagePixelTagModal cart={cart} appId={appId} />
      </div>
      <Space direction="vertical" size={8} className="tags-generated__code-container">
        <Text type="secondary" strong className="tags-generated__code-title">
          GENERATED TAG CODE
        </Text>
        <Card className="tags-code-block">
          <div className="tags-code-block__header">
            <div className="tags-code-block__dots">
              <div className="tags-code-block__dot tags-code-block__dot--red"></div>
              <div className="tags-code-block__dot tags-code-block__dot--yellow"></div>
              <div className="tags-code-block__dot tags-code-block__dot--green"></div>
            </div>
            <Text className="tags-code-block__title">generated-tag.js</Text>
          </div>
          <div className="tags-code-block__copy-wrapper">
            <CodeBlock
              text={generatedTagValue}
              language="javascript"
              theme={GeneratedTagsCardStyles.codeBlockTheme}
              showLineNumbers={true}
              wrapLongLines={false}
              customStyle={{
                ...GeneratedTagsCardStyles.codeBlockCustom,
                padding: space[4],
              }}
            />
            <Tooltip title={isCopied ? 'Copied!' : 'Copy'}>
              <Button
                type="text"
                icon={isCopied ? <CheckOutlined /> : <CopyOutlined />}
                aria-label={isCopied ? 'Copied to clipboard' : 'Copy tag code'}
                onClick={handleCopy}
                className="tags-code-block__copy-btn"
              />
            </Tooltip>
          </div>
        </Card>
      </Space>
    </Card>
  );
};

export default GeneratedTagsCard;
